"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildLink = void 0;
var buildLink = exports.buildLink = function buildLink(linkBase, pageNumber) {
  return pageNumber === 1 ? linkBase : "".concat(linkBase, "/pages/").concat(pageNumber);
};